var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { "max-width": "350" } },
    [
      !_vm.isMobile() && _vm.clubLogo
        ? _c(
            "v-row",
            { staticClass: "pa-4", attrs: { "no-gutters": "" } },
            [
              _c("v-img", {
                attrs: {
                  height: "233",
                  width: "300",
                  src: _vm.base64ImgPrefix + _vm.clubLogo,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("v-card-title", [
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.$t("loginForm.login_title")) },
        }),
      ]),
      _c("v-card-subtitle", [
        _vm._v(_vm._s(_vm.$t("loginForm.login_subTitle")) + " "),
      ]),
      _c(
        "v-form",
        { ref: "loginRegisterForm" },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", justify: "start" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-2 flex-column",
                  staticStyle: { "max-width": "475px" },
                  attrs: { "no-gutters": "", align: "center" },
                },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("common.label_addressNumber"),
                          rules: _vm.commonRules,
                          "prepend-icon": "mdi-account",
                          clearable: "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleLogin.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.loginData.login,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginData, "login", $$v)
                          },
                          expression: "loginData.login",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("common.label_password"),
                          type: _vm.loginData.showPassword
                            ? "text"
                            : "password",
                          "append-icon": _vm.loginData.showPassword
                            ? "mdi-eye"
                            : "mdi-eye-off",
                          rules: _vm.commonRules,
                          "prepend-icon": "mdi-key",
                          clearable: "",
                          hint: _vm.showRegistrationFields
                            ? _vm.$t("loginForm.register_password_info")
                            : "",
                          "persistent-hint": _vm.showRegistrationFields,
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleLogin.apply(null, arguments)
                          },
                          "click:append": function ($event) {
                            _vm.loginData.showPassword =
                              !_vm.loginData.showPassword
                          },
                        },
                        model: {
                          value: _vm.loginData.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginData, "password", $$v)
                          },
                          expression: "loginData.password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.errors.length > 0
            ? _c(
                "v-row",
                { staticClass: "ma-2", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "Detail",
                    {
                      attrs: {
                        containerNoPadding: true,
                        title: _vm.$t("common.label_errorOccured"),
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("v-list-item-title", [
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("common.label_errorOccured")
                                ),
                              },
                            }),
                          ]),
                          _vm._l(_vm.errors, function (error) {
                            return _c(
                              "v-list-item-subtitle",
                              {
                                key: error,
                                staticClass: "red--text",
                                staticStyle: { "white-space": "pre-line" },
                              },
                              [_vm._v(" " + _vm._s(error) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            {
              staticClass: "ma-2",
              attrs: { "no-gutters": "", justify: "center" },
            },
            [
              _c("Detail", {
                attrs: {
                  containerNoPadding: true,
                  title: _vm.$t("loginForm.login_addressNr_title"),
                  subTitle: _vm.$t("loginForm.login_addressNr_description"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c(
            "v-row",
            {
              staticClass: "ma-2",
              attrs: { "no-gutters": "", justify: "end", align: "end" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.loading, color: "primary white--text" },
                  on: { click: _vm.handleLogin },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("loginForm.login_action_login")) + " "
                  ),
                  _c("v-icon", { attrs: { right: "" } }, [
                    _vm._v(" mdi-login "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }